import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches ALL entities from get-entities API for download purposes.
 * Uses a large pageSize to get everything in one call.
 *
 * @param {object} filters - optional filters
 * @returns {{ success: boolean, data: Array, error?: string }}
 */
export const fetchAllEntitiesForDownloadAction = async (filters = {}) => {
  try {
    const body = {
      id: null,
      category: filters.entityCategory || null,
      searchValue: filters.searchValue || null,
      requireKYC: filters.requireKYC ?? null,
      documentStatus:
        filters.documentStatus === "Done"
          ? true
          : filters.documentStatus === "pending"
            ? false
            : null,
      isVerified: filters.isVerified ?? null,
      isRegisterdUnderMSME: filters.isRegisteredUnderMSME ?? null,
      entityLOBType: filters.lobType || null,
      startDate: filters.startDate || null,
      endDate: filters.endDate || null,
      pageNumber: 1,
      pageSize: 500,
    };

    const response = await apiClient.post(
      ATP_API_URL.GET_ALL_DATA_SEARCH,
      body,
    );

    if (response?.status === 200 && response.data) {
      const raw = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      return { success: true, data: raw };
    }

    return { success: false, data: [], error: "No data returned" };
  } catch (error) {
    return { success: false, data: [], error: error.message };
  }
};
